// extracted by mini-css-extract-plugin
export default {"title":"zJSnT","text":"q7Egw","container":"bsQwq","faceEmoji":"XDuVw","button":"jORq8"};